const CLARITY_ID = import.meta.env.VITE_CLARITY_PROJECT_ID;
const CONSENT_KEY = 'privacy-consent';

function hasRejected(): boolean {
  try {
    return localStorage.getItem(CONSENT_KEY) === 'rejected';
  } catch {
    return false;
  }
}

function injectClarity(): void {
  if (!CLARITY_ID || typeof document === 'undefined') return;
  if (document.getElementById('ms-clarity')) return;

  const script = document.createElement('script');
  script.id = 'ms-clarity';
  script.innerHTML = `(function(c,l,a,r,i,t,y){
    c[a]=c[a]||function(){(c[a].q=c[a].q||[]).push(arguments)};
    t=l.createElement(r);t.async=1;t.src="https://www.clarity.ms/tag/"+i;
    y=l.getElementsByTagName(r)[0];y.parentNode.insertBefore(t,y);
  })(window,document,"clarity","script","${CLARITY_ID}");`;
  document.head.appendChild(script);
}

function removeClarity(): void {
  const existing = document.getElementById('ms-clarity');
  if (existing) existing.remove();
}

export function initClarity(): void {
  if (typeof window === 'undefined' || !import.meta.env.PROD) return;

  if (!hasRejected()) injectClarity();

  window.addEventListener('consentChanged', (e: Event) => {
    const { status } = (e as CustomEvent<{ status: 'accepted' | 'rejected' }>).detail;
    if (status === 'rejected') {
      removeClarity();
    } else {
      injectClarity();
    }
  });
}
